export default "__VITE_ASSET__DReS8EuR__";